import { useMemo } from "react";

import NavigationBar from "../Common/NavigationBar";

import { authorized } from "../../utils/authorizationUtils";

import { bypatruljen, juridisk } from "../../constants/roles";
import sitePaths from "../../constants/sitePaths";

export default function NavigationBarContainer() {
  const navigationItems = useMemo(() => {
    const authorizedEttersendelser = authorized([
      bypatruljen.saksbehandler,
      bypatruljen.saksbehandleradmin,
      bypatruljen.avdelingdirektor,
      bypatruljen.seksjonssjefStab,
    ]);
    const authorizedEttersendelserTilGodkjenning = authorized([
      bypatruljen.saksbehandler,
      bypatruljen.saksbehandleradmin,
    ]);
    const authorizedElsparksykkelGebyr = authorized([
      bypatruljen.saksbehandler,
      bypatruljen.saksbehandleradmin,
      bypatruljen.avdelingdirektor,
      bypatruljen.seksjonssjefStab,
      bypatruljen.seksjonssjef,
      bypatruljen.driftleder,
      juridisk.ledelse,
      juridisk.saksbehandler,
    ]);

    let items = [
      {
        navn: "Ileggelsesoversikt",
        path: sitePaths.ileggelser.oversikt.shortUrl,
      },
    ];
    if (authorizedEttersendelser) {
      items = [
        ...items,
        {
          navn: "Ettersendelser",
          path: sitePaths.ileggelser.ettersendelser.shortUrl,
        },
      ];
    }
    if (authorizedEttersendelserTilGodkjenning) {
      items = [
        ...items,
        {
          navn: "Ettersendelser til godkjenning",
          path: sitePaths.ileggelser.ettersendelserTilGodkjenning.shortUrl,
        },
      ];
    }
    if (authorizedElsparksykkelGebyr) {
      items = [
        ...items,
        {
          navn: "ELS",
          path: sitePaths.ileggelser.elsparksykkelGebyr.shortUrl,
        },
      ];
    }
    return items;
  }, []);

  return <NavigationBar navigationItems={navigationItems} />;
}
